import React from 'react';

export const TabContext = React.createContext({});

export const useTabContext = () => React.useContext(TabContext);
